/**
 * @fileoverview Layout-specific React context for sidebar navigation items.
 */

import * as React from 'react';
import type { SidebarPageItemContextProps } from './SidebarPageItem';

/**
 * Context providing sidebar page item configuration and callbacks.
 */
export const SidebarPageItemContext = React.createContext<SidebarPageItemContextProps | null>(null);
